var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.openInAdmin)?_c('a',{attrs:{"href":_vm.adminHref,"title":_vm.product.mainTitle,"target":_vm.adminTarget}},[_vm._t("default")],2):_c('router-link',{attrs:{"to":_vm.route,"title":_vm.product.mainTitle}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }